

export const CHANGE_ENTITY = "CHANGE_ENTITY"